module.exports = __webpack_public_path__ + "static/endy-logo-e02915aa49ac76d2c87972aad9353959.jpg";